import i18n from "i18n";

export const mediaMessages = {
  delete: i18n.t('notifications.media.delete'),
  clone: i18n.t('notifications.media.clone'),
}
